import React from 'react'
import leftBtn from '@/assets/images/leftbtn.png'
import './index.scss'
const Header = (props) => {
  let { tit } = props;

  const handleGoBackHeader = () => {
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //android
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      // window.handleGoBack();//这里的.android是安卓那边定义的类,可以随便定义,但这里必须要跟安卓那边统一
      window.handleGoBack.pop()
    } else if (isIOS) {
      // window.webkit.messageHandlers.handleGoBack.postMessage({});
      window.WebViewJavascriptBridge.callHandler('handleGoBack');
    }
  }
  return (
    <header className="common-header">
      <em onClick={handleGoBackHeader}><img src={leftBtn} alt="" /></em>
      <span>{tit}</span>
      { props.children}
    </header>
  )
}
export default Header
